@if (isOnline && !noEvent){


<div class="container-fluid mb-3 p-3 dashboard__header">


  <div class="row">
    <div class="col-3">
      <div class="client-menu client-menu-right">
        <button (click)="goBack();" mat-icon-button>
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
    </div>
    <div class="col-6 d-flex align-items-center justify-content-center">
      <img class="img-fluid" src="../assets/Winning_Hands_Logo_Black-300x100.png">
    </div>
    <div class="col-3 justify-content-end d-flex">
      <button [matMenuTriggerFor]="userMenu" mat-button><img class="img-fluid rounded-pill"
     style="max-height: 40px; aspect-ratio: 1/1;" src="{{therapistDetail.profileSmallURL ? therapistDetail.profileSmallURL : therapistDetail.profileLargeURL}}"></button>
      <mat-menu #userMenu="matMenu">
        @if (therapistDetail.therapistStatusID !== 2){
        <button [disabled]="actionButtonClicked" (click)="clockOutUser();" mat-menu-item>CLOCK OUT</button>
        }
        <button [disabled]="actionButtonClicked" (click)="logOutUser();" mat-menu-item>LOG OFF</button>

        @if (therapistDetail.therapistStatusID === 4){
        <button [disabled]="actionButtonClicked" (click)="endBreak();" mat-menu-item>END BREAK</button>
        }@else{
        <button [disabled]="actionButtonClicked" (click)="startBreak();" mat-menu-item>TAKE BREAK</button>

        }



        @if (this.acceptBookings){
        <button [disabled]="actionButtonClicked" (click)="stopBookings();" mat-menu-item>STOP TAKING BOOKINGS</button>

        }@else {
        <button [disabled]="actionButtonClicked" (click)="startBookings();" mat-menu-item>ACCEPT BOOKINGS</button>

        }
      </mat-menu>
    </div>

  </div>
</div>
<div class="container-fluid p-4 body__container">
  <div class="contianer">

    @if (therapistEventData && therapistEventData.eventId && therapistEventData.eventId > 0){
    <div class="row">
      <div class="col text-center">
        <h3 class="h5 mb-1">{{therapistEventData.eventName}}</h3>
        <p class="mb-0 text-muted small">{{therapistEventData.eventStartDate|date:'dd MMM YYYY'}} -
          {{therapistEventData.eventEndDate|date:'dd MMM YYYY'}}</p>
      </div>
    </div>
    }

    @if (therapistDetail && !therapistDetail.acceptBookings){
    <div class="card status-card p-4 my-3">
      <div class="row text-center">
        <div class="col-12">
          <mat-icon>info</mat-icon>
        </div>
        <div class="col-12">
          <p>You are currently not accepting bookings</p>

        </div>
        <div class="col-12">
          <button [disabled]="actionButtonClicked" (click)="startBookings();" class="w-100" color="primary"
            mat-flat-button>ACCEPT BOOKINGS</button>

        </div>
      </div>
    </div>
    }

    @if (therapistDetail && therapistDetail.therapistStatusID === 4){
    <div class="card status-card p-4 my-3">
      <div class="row text-center">
        <div class="col-12">
          <mat-icon>coffee</mat-icon>
        </div>
        <div class="col-12">
          <p>You are currently on a break</p>

        </div>
        <div class="col-12">
          <button [disabled]="actionButtonClicked" (click)="endBreak();" class="w-100" color="primary"
            mat-flat-button>END BREAK</button>

        </div>
      </div>
    </div>
    }

    <router-outlet></router-outlet>
  </div>
</div>
}
@else if (noEvent){
<div class="container-fluid">
  <div class="row my-5 d-flex justify-content-center">
    <div class="col-6  d-flex align-items-center justify-content-center">
      <img class="img-fluid" src="../assets/Winning_Hands_Logo_Black-300x100.png">
    </div>
  </div>
  <div class="row my-5 text-center">
    <div class="col">
      <mat-icon style="color: #75d1d4; width: 50px; height: 50px; font-size: 50px;">event</mat-icon>
    </div>
    <div class="row">
      <div class="col">
        <h2>You are not associated to any active events</h2>
      </div>
    </div>

  </div>

</div>
}
@else{
<div class="container-fluid">
  <div class="row my-5 d-flex justify-content-center">
    <div class="col-6  d-flex align-items-center justify-content-center">
      <img class="img-fluid" src="../assets/Winning_Hands_Logo_Black-300x100.png">
    </div>
  </div>
  <div class="row my-5 text-center">
    <div class="col">
      <mat-icon style="color: #75d1d4; width: 50px; height: 50px; font-size: 50px;">wifi_off</mat-icon>
    </div>
    <div class="row">
      <div class="col">
        <h2>Please check your internet connection</h2>
        <p>Your device currently has no internet connection, please check your connection and try again.</p>
      </div>
    </div>

  </div>

</div>

}
